// Parent area (/, /shop, /orders, /profile, /cart): guard, then the school header above a stack
// (FR-013, FR-014, FR-016; R-2, R-7; routes.md).
import { Stack } from "expo-router";
import { StyleSheet, View } from "react-native";

import { ParentDataSync } from "@/profile/ParentDataSync";
import { SchoolHeader } from "@/shell/header/SchoolHeader";
import { RouteGuard } from "@/shell/RouteGuard";
import { makeStyles } from "@/theme/makeStyles";

const useStyles = makeStyles((t) =>
  StyleSheet.create({
    area: { flex: 1, backgroundColor: t.color.background },
  }),
);

export default function ParentLayout() {
  const styles = useStyles();
  return (
    <RouteGuard area="parent">
      <View style={styles.area}>
        {/* 004 FR-046: the header follows the selected child's school. */}
        <ParentDataSync />
        <SchoolHeader />
        <Stack
          screenOptions={{
            headerShown: false,
            contentStyle: styles.area,
          }}
        />
      </View>
    </RouteGuard>
  );
}

// A screen that throws shows the themed fallback (FR-041; US6-2).
export { ErrorFallback as ErrorBoundary } from "@/shell/ErrorFallback";
